import type { LGSPrefs } from "@/types/user";

export function buildLgsSearchUrl(prefs: LGSPrefs, cardName: string) {
  const q = encodeURIComponent(cardName.trim());
  if (prefs.websiteSearchTemplate && prefs.websiteSearchTemplate.includes("{q}")) {
    return prefs.websiteSearchTemplate.replace("{q}", q);
  }
  const base = (prefs.listingsUrl || prefs.websiteUrl || "").trim();
  const sep = base.includes("?") ? "&" : "?";
  return `${base}${sep}q=${q}`;
}
